<template>
  <div :style="{ width: '100%', marginLeft: '20%', height: '100%' }">
    <v-layout row wrap class="mt-4" justify-center>
      <v-flex xs6 v-for="(item, index) in settings" :key="index">
        <v-card color="primary" class="ma-2">
          <v-card-title>
            <h3>{{ item.name }}</h3>
          </v-card-title>
          <v-divider class="mb-4" />
          <v-select
            color="secondary"
            class="mx-auto"
            :style="{ width: '20vw' }"
            :items="possibleLimits"
            v-model="item.value"
            label="Total Locations to Evaluate"
          ></v-select>
          <v-card-actions class="mt-2">
            <v-spacer />
            <v-btn
              large
              color="success darken-2"
              flat
              small
              @click="updateSetting({ body: item, id: item._id })"
              >Update Limit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "InventoryBody",

  data() {
    return {
      possibleLimits: [5, 10, 15, 20, 25, 30, 35, 40]
    };
  },
  computed: {
    ...mapGetters({
      settings: "settings/getSettings"
    })
  },

  mounted() {
    this.getSettings("inventory");
  },

  methods: {
    ...mapActions({
      getSettings: "settings/getSettings",
      updateSetting: "settings/updateSetting"
    })
  }
};
</script>

<style></style>
